
import {useEffect, useState} from "react";
import Button from "../components/Button";
import Modal from "../../../components/Modal";
import ClassesTable from "./components/ClassesTable";
import ButtonImg from "../components/ButtonImg";
import MakeClassBtn from "../../../assets/images/classes/add_class_btn.svg";
import ModifyFinClassBtn from "../../../assets/images/classes/modify_fin_btn.svg";
import ModifyClassBtn from "../../../assets/images/classes/modify_btn.svg";
import {deleteClasses, makeClass} from "../../../network/Endpoint";
import {messageToast} from "../../../components/Toast";
import {cloneDeep} from "lodash";
import {useRecoilState} from "recoil";
import {classesState} from "../../../recoil/classes/classesState";

const ClassManagementPage = ({teacherId, setMainClass, mainClass, setModifyCheck, isEditable, setIsEditable, fetchUpdateClasses, updateClassesInfo, setUpdateClassesInfo, setUpdatedClasses}) => {
    const [classes, setClasses] = useRecoilState(classesState); // classes atom 업데이트
    const [formClasses,setFormClasses] = useState(cloneDeep(classes));
    const [newClassName, setNewClassName] = useState('');
    const [deleteIndex, setDeleteIndex] = useState(null);

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);


    const fetchMakeClass = async (className) => {
        try {
            const body = {
                teacherId: teacherId,
                name: className
            };
            const res = await makeClass(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const clazz = cloneDeep(res.data.data.clazz);
                setClasses([clazz, ...classes]);
                setFormClasses([clazz, ...classes]);
                setMainClass(clazz);
                messageToast({message:"클래스가 생성되었습니다.", description:className});
                setModifyCheck(true);

            } else {
                alert(`ERROR: 클래스 생성중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('클래스 생성중 오류가 발생했어요. \n아크수학으로 문의해 주세요.');
        }
    };

    const fetchDeleteClass = async (clazz) => {
        try {
            const body = {
                teacherId: teacherId,
                classId: clazz.classId
            };
            const res = await deleteClasses(body);
            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                let modClasses =classes.filter((_, index) => index !== deleteIndex);
                setClasses(modClasses);
                setFormClasses(modClasses);
                if(clazz.classId === mainClass.classId){
                    setMainClass(modClasses[0]);
                }
                messageToast({message:"클래스가 삭제되었습니다.", description:clazz.name});
                setModifyCheck(true);
            } else {
                alert(`ERROR: 클래스 삭제중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('클래스 삭제중 오류가 발생했어요. \n아크수학으로 문의해 주세요.');
        }
    };


    const handleCreateClass = () => {
        fetchMakeClass(newClassName);
        setNewClassName('');
        setIsCreateModalOpen(false);
    };

    const handleDeleteClass = () => {
        fetchDeleteClass(classes[deleteIndex])
        setDeleteIndex(null);
        setIsDeleteModalOpen(false);
    };

    const handleEditChange = (index, value, formData) => {
        // 🔹 기존 formData를 직접 수정하지 않고 새로운 배열 생성
        let tempClasses = formData.map((item, i) =>
            i === index ? { ...item, name: value } : item
        );

        // updateClassesInfo에서 해당 index가 이미 있는지 확인
        const existingIndex = updateClassesInfo.findIndex(
            (item) => item.classId === tempClasses[index].classId
        );

        let newUpdateClassesInfo;
        if (existingIndex !== -1) {
            // 기존 객체가 있다면 업데이트
            newUpdateClassesInfo = [...updateClassesInfo];
            newUpdateClassesInfo[existingIndex] = { ...tempClasses[index] };
        } else {
            // 없으면 새로 추가
            newUpdateClassesInfo = [...updateClassesInfo, tempClasses[index]];
        }
        setFormClasses(tempClasses);
        setUpdateClassesInfo(newUpdateClassesInfo);
        setUpdatedClasses(tempClasses); // ✅ 새로운 배열을 설정하여 React가 변경을 감지하도록 함
    };


    const ClickEditBtn = () => {
        if(isEditable && updateClassesInfo.length>0){
            fetchUpdateClasses(true);
        }
        setIsEditable(!isEditable);
    }


    return (
        <>
            <div
                className="flex justify-center mt-8 text-xl font-medium text-center text-zinc-600 max-md:max-w-full">
                클래스를 생성/삭제하거나 생성된 클래스의 정보를 수정할 수 있습니다.
            </div>
            <div className="sticky top-0 z-10 bg-[#F8F8F8] w-full">
                <div className="w-full flex justify-center items-center ">
                    <div className="flex flex-wrap justify-end  mb-6 mt-16 w-[1044px]">
                        <div className="flex gap-4">
                            <ButtonImg
                                image={MakeClassBtn}
                                label="클래스 생성"
                                onClick={() => setIsCreateModalOpen(true)}
                            />
                            <ButtonImg
                                image={isEditable ? ModifyFinClassBtn : ModifyClassBtn}
                                label={isEditable ? "수정 완료" : "정보 수정"}
                                onClick={() => ClickEditBtn()}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ClassesTable
                data={formClasses}
                onDelete={(index) => {
                    setDeleteIndex(index);
                    setIsDeleteModalOpen(true);
                }}
                isEditable={isEditable}
                onEditChange={handleEditChange}
            />

            {/* 클래스 생성 모달 */}
            <Modal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">클래스 생성</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <div className="mt-[35px] mb-[20px] text-[20px] font-[700]">클래스 이름</div>
                <input
                    type="text"
                    value={newClassName}
                    onChange={(e) => setNewClassName(e.target.value)}
                    className="w-[349px] h-12 bg-white rounded-[10px] border-2 border-[#557cfc] px-4 py-2 mb-8 "
                />
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsCreateModalOpen(false)}
                    />
                    <Button label="생성하기" onClick={handleCreateClass}/>
                </div>
            </Modal>

            {/* 삭제 확인 모달 */}
            <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">클래스 삭제</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <div className="my-8 text-2xl font-normal">
                    <span
                        className="text-[#355bdf]">[{classes && classes[deleteIndex] && classes[deleteIndex].name}]</span><br/>
                    <div className="text-base leading-tight">클래스와 클래스의 데이터가 모두 삭제되며,<br/>관련 서비스에서 모두 삭제됩니다.<br/>
                    <span className="text-sm">(관련 서비스: 미니북, 아크수학, 툴킷, AI매일수학, AI평어, 띵커벨, 클래스 툴)</span></div></div>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsDeleteModalOpen(false)}
                    />
                    <Button label="삭제하기" onClick={handleDeleteClass}/>
                </div>
            </Modal>
        </>
    )
}

export default ClassManagementPage;